import { render, staticRenderFns } from "./AIModelList.vue?vue&type=template&id=c82e6580&scoped=true"
import script from "./AIModelList.vue?vue&type=script&lang=js"
export * from "./AIModelList.vue?vue&type=script&lang=js"
import style0 from "./AIModelList.vue?vue&type=style&index=0&id=c82e6580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82e6580",
  null
  
)

export default component.exports